import { render, staticRenderFns } from "./hero.vue?vue&type=template&id=ec2c81dc&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"
import style0 from "./hero.vue?vue&type=style&index=0&id=ec2c81dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2c81dc",
  null
  
)

export default component.exports